import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0 d-flex justify-content-between w-100" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "d-flex gap-6" }
const _hoisted_6 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label" }, "Override horse capacity", -1)
const _hoisted_8 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label" }, "Add customer to existing lesson ", -1)
const _hoisted_10 = { class: "collapse show" }
const _hoisted_11 = { class: "card-body border-top p-9" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label fw-bold fs-6 required" }
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "row mb-6" }
const _hoisted_18 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_19 = { class: "col-lg-8 fv-row" }
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "row mb-6" }
const _hoisted_23 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_24 = { class: "col-lg-8 fv-row" }
const _hoisted_25 = { class: "fv-plugins-message-container" }
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = { class: "row mb-6" }
const _hoisted_28 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_29 = { class: "col-lg-8 fv-row" }
const _hoisted_30 = { class: "fv-plugins-message-container" }
const _hoisted_31 = { class: "fv-help-block" }
const _hoisted_32 = { class: "row mb-6" }
const _hoisted_33 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_34 = { class: "required" }
const _hoisted_35 = { class: "col-lg-8 fv-row" }
const _hoisted_36 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "fv-plugins-message-container" }
const _hoisted_39 = { class: "fv-help-block" }
const _hoisted_40 = { class: "row mb-6" }
const _hoisted_41 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_42 = { class: "required" }
const _hoisted_43 = { class: "col-lg-8 fv-row" }
const _hoisted_44 = { class: "fv-plugins-message-container" }
const _hoisted_45 = { class: "fv-help-block" }
const _hoisted_46 = { class: "row mb-6" }
const _hoisted_47 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_48 = { class: "col-lg-8 fv-row" }
const _hoisted_49 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_50 = ["value"]
const _hoisted_51 = { class: "fv-plugins-message-container" }
const _hoisted_52 = { class: "fv-help-block" }
const _hoisted_53 = { class: "row mb-6" }
const _hoisted_54 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_55 = { class: "required" }
const _hoisted_56 = { class: "col-lg-8 fv-row" }
const _hoisted_57 = { class: "fv-plugins-message-container" }
const _hoisted_58 = { class: "fv-help-block" }
const _hoisted_59 = { class: "row mb-6" }
const _hoisted_60 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_61 = { class: "required" }
const _hoisted_62 = { class: "col-lg-8 fv-row" }
const _hoisted_63 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_64 = ["value"]
const _hoisted_65 = { class: "fv-plugins-message-container" }
const _hoisted_66 = { class: "fv-help-block" }
const _hoisted_67 = { class: "row mb-6" }
const _hoisted_68 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_69 = { class: "required" }
const _hoisted_70 = { class: "col-lg-8 fv-row" }
const _hoisted_71 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_72 = ["hidden", "value"]
const _hoisted_73 = { class: "fv-plugins-message-container" }
const _hoisted_74 = { class: "fv-help-block" }
const _hoisted_75 = { class: "row mb-6" }
const _hoisted_76 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_77 = { class: "col-lg-8 fv-row" }
const _hoisted_78 = { class: "fv-plugins-message-container" }
const _hoisted_79 = { class: "fv-help-block" }
const _hoisted_80 = { class: "row mb-6" }
const _hoisted_81 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_82 = { class: "col-lg-8 fv-row" }
const _hoisted_83 = { class: "card-body border-top p-9" }
const _hoisted_84 = { class: "card-title m-0" }
const _hoisted_85 = { class: "fw-bolder mb-5" }
const _hoisted_86 = { class: "col-md-3" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Customer:", -1)
const _hoisted_88 = { class: "fv-plugins-message-container" }
const _hoisted_89 = { class: "fv-help-block" }
const _hoisted_90 = {
  key: 0,
  style: {"max-width":"310px"},
  class: "text-danger"
}
const _hoisted_91 = { class: "col-md-3" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Horse:", -1)
const _hoisted_93 = { class: "fv-plugins-message-container" }
const _hoisted_94 = { class: "fv-help-block" }
const _hoisted_95 = { class: "col-md-3" }
const _hoisted_96 = { class: "form-label" }
const _hoisted_97 = {
  key: 0,
  style: {"max-width":"310px"},
  class: "text-danger text-end"
}
const _hoisted_98 = { class: "col-md-3" }
const _hoisted_99 = ["onClick"]
const _hoisted_100 = /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-trash fs-5" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path3" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path4" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path5" })
], -1)
const _hoisted_101 = { class: "form-group mt-5" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-plus fs-3" }, null, -1)
const _hoisted_103 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_104 = ["disabled"]
const _hoisted_105 = { class: "indicator-label" }
const _hoisted_106 = { class: "indicator-progress" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_SearchField = _resolveComponent("SearchField")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('create', 'arena'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('createNewLesson')), 1),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("label", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.horseQuery.ignoreCapacity) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.horseQuery.ignoreCapacity]
                ]),
                _hoisted_7
              ]),
              _createElementVNode("label", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isUpdating) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.isUpdating]
                ]),
                _hoisted_9
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitCreate,
            "validation-schema": _ctx.validationSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.translate('Days')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_Field, {
                      name: "days",
                      modelValue: _ctx.horseQuery.days,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.horseQuery.days) = $event)),
                      onChange: _cache[5] || (_cache[5] = ($event: any) => {
                  _ctx.checkAllBalance();
                  _ctx.checkAllGroomer();
                })
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Multiselect, {
                          mode: "tags",
                          "close-on-select": false,
                          requierd: false,
                          label: "nameEn",
                          trackBy: "nameEn",
                          searchable: true,
                          canDeselect: false,
                          placeholder: _ctx.translate('Select day'),
                          valueProp: "id",
                          options: _ctx.dayList,
                          noResultsText: _ctx.translate('noResultsFound'),
                          "allow-empty": false,
                          required: true,
                          modelValue: _ctx.horseQuery.days,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.horseQuery.days) = $event)),
                          onChange: _cache[3] || (_cache[3] = ($event: any) => {
                    _ctx.checkAllBalance();
                    _ctx.checkAllGroomer();
                  })
                        }, null, 8, ["placeholder", "options", "noResultsText", "modelValue"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_ErrorMessage, { name: "days" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.translate('Number Of Lessons')), 1),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "numberOfLessons",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('Number Of Lessons'),
                      modelValue: _ctx.horseQuery.numberOfLessons,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.horseQuery.numberOfLessons) = $event)),
                      onChange: _cache[7] || (_cache[7] = ($event: any) => {
                  _ctx.checkAllBalance();
                  _ctx.checkAllGroomer();
                })
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_ErrorMessage, { name: "numberOfLessons" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.translate('startDate')), 1),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_Field, {
                      name: "startDate",
                      modelValue: _ctx.horseQuery.startDate,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.horseQuery.startDate) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DatePicker, {
                          id: "startDate",
                          class: "form-control form-control-lg form-control-solid",
                          modelValue: _ctx.horseQuery.startDate,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.horseQuery.startDate) = $event)),
                          placeholder: _ctx.translate('dd/mm/yyyy'),
                          fieldId: "startDate",
                          onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleDateChange(_ctx.horseQuery.startDate)))
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_ErrorMessage, { name: "startDate" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.translate('Lesson Time')), 1),
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_Field, {
                      type: "time",
                      name: "time",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('lessonTime'),
                      modelValue: _ctx.horseQuery.time,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.horseQuery.time) = $event)),
                      onChange: _cache[12] || (_cache[12] = ($event: any) => {
                  _ctx.checkAllBalance();
                  _ctx.checkAllGroomer();
                })
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_ErrorMessage, { name: "time" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("label", _hoisted_33, [
                    _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.translate('Class Category')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "classCategoryId",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.selectedCategory,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedCategory) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_36, _toDisplayString(_ctx.translate('select class Category')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryList, (category) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: category.id,
                            value: category.id
                          }, _toDisplayString(category.nameEn), 9, _hoisted_37))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createVNode(_component_ErrorMessage, { name: "classCategoryId" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("label", _hoisted_41, [
                    _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.translate('Arenas')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createVNode(_component_Field, {
                      name: "arenaId",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.selectedArenaId,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.selectedArenaId) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_SearchField, {
                          modelValue: _ctx.selectedArenaId,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.selectedArenaId) = $event)),
                          options: _ctx.arenaList,
                          mode: "single",
                          label: _ctx.translate('Select arena'),
                          className: "form-select-md"
                        }, null, 8, ["modelValue", "options", "label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _createVNode(_component_ErrorMessage, { name: "arenaId" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.translate('Class Level')), 1),
                  _createElementVNode("div", _hoisted_48, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "classLevelId",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.selectedLevel,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.selectedLevel) = $event)),
                      style: _normalizeStyle({ color: _ctx.levelColor }),
                      onChange: _ctx.handleLevelColor
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_49, _toDisplayString(_ctx.translate('Class Level')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.matchedClassLevelList, (levelList) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: levelList.id,
                            style: _normalizeStyle({ color: levelList.color }),
                            value: levelList.id
                          }, _toDisplayString(levelList.name), 13, _hoisted_50))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "style", "onChange"]),
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _createVNode(_component_ErrorMessage, { name: "classLevelId" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("label", _hoisted_54, [
                    _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.translate('Trainer')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createVNode(_component_Field, {
                      name: "trainerId",
                      modelValue: _ctx.selectedTrainer,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.selectedTrainer) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_SearchField, {
                          onChange: _ctx.checkAllBalance,
                          modelValue: _ctx.selectedTrainer,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.selectedTrainer) = $event)),
                          options: _ctx.trainerList,
                          mode: "single",
                          label: _ctx.translate('Select trainer'),
                          className: "form-select-md"
                        }, null, 8, ["onChange", "modelValue", "options", "label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, [
                        _createVNode(_component_ErrorMessage, { name: "trainerId" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("label", _hoisted_60, [
                    _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.translate('Class Type')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_62, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "typeId",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.selectedClassType,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.selectedClassType) = $event)),
                      onChange: _ctx.checkAllBalance
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_63, _toDisplayString(_ctx.translate('select Class Type')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classTypeList, (classType) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: classType.id,
                            value: classType.id
                          }, _toDisplayString(classType.nameEn), 9, _hoisted_64))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"]),
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("div", _hoisted_66, [
                        _createVNode(_component_ErrorMessage, { name: "typeId" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("label", _hoisted_68, [
                    _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.translate('Duration')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_70, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "durationId",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.horseQuery.durationId,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.horseQuery.durationId) = $event)),
                      onChange: _cache[21] || (_cache[21] = ($event: any) => {
                  _ctx.checkAllBalance();
                  _ctx.checkAllGroomer();
                })
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_71, _toDisplayString(_ctx.translate('select duration')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.durationList, (duration) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: duration.id,
                            hidden: duration.slug == 60 || duration.slug == 15,
                            value: duration.id
                          }, _toDisplayString(duration.nameEn), 9, _hoisted_72))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("div", _hoisted_74, [
                        _createVNode(_component_ErrorMessage, { name: "durationId" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("label", _hoisted_76, _toDisplayString(_ctx.translate('Max number of riders')), 1),
                  _createElementVNode("div", _hoisted_77, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "numberOfRiders",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('Number of riders'),
                      modelValue: _ctx.numberOfRiders,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.numberOfRiders) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_78, [
                      _createElementVNode("div", _hoisted_79, [
                        _createVNode(_component_ErrorMessage, { name: "numberOfRiders" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("label", _hoisted_81, _toDisplayString(_ctx.translate('comment')), 1),
                  _createElementVNode("div", _hoisted_82, [
                    _createVNode(_component_Field, {
                      type: "text",
                      as: "textarea",
                      name: "comment",
                      autocomplete: "off",
                      rows: "5",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('comment')
                    }, null, 8, ["placeholder"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_83, [
                _createElementVNode("div", _hoisted_84, [
                  _createElementVNode("h3", _hoisted_85, _toDisplayString(_ctx.translate('Riders')), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.riders, (rider, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "form-group row m-5"
                  }, [
                    _createElementVNode("div", _hoisted_86, [
                      _hoisted_87,
                      _createVNode(_component_Field, {
                        name: `customerId_${index}`,
                        class: "form-select form-select-solid form-select-lg text-capitalize",
                        modelValue: _ctx.selectedCustomers[index],
                        "onUpdate:modelValue": ($event: any) => ((_ctx.selectedCustomers[index]) = $event)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_SearchField, {
                            modelValue: _ctx.selectedCustomers[index],
                            "onUpdate:modelValue": ($event: any) => ((_ctx.selectedCustomers[index]) = $event),
                            onChange: ($event: any) => (
                    _ctx.handleChangedCustomer(
                      _ctx.selectedCustomers[index],
                      index,
                      rider.horseId
                    )
                  ),
                            options: _ctx.customerList,
                            mode: "single",
                            label: _ctx.translate('Select customer'),
                            className: "form-select-md"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "options", "label"])
                        ]),
                        _: 2
                      }, 1032, ["name", "modelValue", "onUpdate:modelValue"]),
                      _createElementVNode("div", _hoisted_88, [
                        _createElementVNode("div", _hoisted_89, [
                          _createVNode(_component_ErrorMessage, {
                            name: `customerId_${index}`
                          }, null, 8, ["name"])
                        ])
                      ]),
                      (rider.haveBalance)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_90, _toDisplayString(rider.haveBalance), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_91, [
                      _hoisted_92,
                      _createVNode(_component_Field, {
                        name: `horseId_${index}`,
                        class: "form-select form-select-solid form-select-lg text-capitalize",
                        modelValue: rider.horseId,
                        "onUpdate:modelValue": ($event: any) => ((rider.horseId) = $event)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_SearchField, {
                            modelValue: rider.horseId,
                            "onUpdate:modelValue": ($event: any) => ((rider.horseId) = $event),
                            onChange: ($event: any) => (_ctx.checkBalance(rider.horseId, index)),
                            options: _ctx.horsesList[index],
                            mode: "single",
                            label: _ctx.translate('Select horse'),
                            className: "form-select-md",
                            hiddenItem: _ctx.hiddenHorsesIds,
                            trackBy: "nameEn"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "options", "label", "hiddenItem"])
                        ]),
                        _: 2
                      }, 1032, ["name", "modelValue", "onUpdate:modelValue"]),
                      _createElementVNode("div", _hoisted_93, [
                        _createElementVNode("div", _hoisted_94, [
                          _createVNode(_component_ErrorMessage, {
                            name: `horseId_${index}`
                          }, null, 8, ["name"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_95, [
                      _createElementVNode("label", _hoisted_96, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.translate('Groomer')), 1)
                      ]),
                      _createVNode(_component_Field, {
                        name: `groomerId_${index}`,
                        class: "form-select form-select-solid form-select-lg text-capitalize",
                        modelValue: rider.groomerId,
                        "onUpdate:modelValue": ($event: any) => ((rider.groomerId) = $event)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_SearchField, {
                            modelValue: rider.groomerId,
                            "onUpdate:modelValue": ($event: any) => ((rider.groomerId) = $event),
                            options: _ctx.groomerList,
                            mode: "single",
                            label: _ctx.translate('Select Groomer'),
                            className: "form-select-md",
                            hiddenItem: _ctx.hiddenGroomerIds
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "label", "hiddenItem"])
                        ]),
                        _: 2
                      }, 1032, ["name", "modelValue", "onUpdate:modelValue"]),
                      (rider.validGroomer)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_97, _toDisplayString(rider.validGroomer), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_98, [
                      _createElementVNode("p", {
                        onClick: ($event: any) => (_ctx.removeRider(index)),
                        class: "btn btn-sm btn-light-danger mt-3 mt-md-8"
                      }, [
                        _hoisted_100,
                        _createTextVNode(" Delete ")
                      ], 8, _hoisted_99)
                    ])
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_101, [
                  _createElementVNode("span", {
                    onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.addNewRider && _ctx.addNewRider(...args))),
                    class: "btn btn-light-primary",
                    type: "btn"
                  }, [
                    _hoisted_102,
                    _createTextVNode(" Add ")
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_103, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                _createElementVNode("button", {
                  disabled: _ctx.disabledSubmit,
                  type: "submit",
                  id: "kt_account_profile_details_submit",
                  ref: "submitButton",
                  class: "btn btn-primary"
                }, [
                  _createElementVNode("span", _hoisted_105, _toDisplayString(_ctx.translate('saveChanges')), 1),
                  _createElementVNode("span", _hoisted_106, [
                    _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                    _hoisted_107
                  ])
                ], 8, _hoisted_104)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}